<template>
  <div>
    <Structure />
    <Criteria class="mt-4" />
  </div>
</template>

<script>
import Structure from "@/components/minimum.wage/pages/Criteria/CriteriaStructureManagement.vue";
import Criteria from "@/components/minimum.wage/pages/Criteria/CriteriaManagement.vue";
export default {
  components: {
    Structure,
    Criteria,
  },
};
</script>

<style lang="scss" scoped></style>
